import { z } from 'zod';

export const stripeAddressSchema = z.object({
  line1: z.string().optional(),
  line2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  postal_code: z.string(),
  country: z.string(),
});

export type StripeAddress = z.infer<typeof stripeAddressSchema>;
